import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const EXTERNAL_API_URL = process.env.REACT_APP_API_URL;

// Internal FastAPI backend (prefixed with /api)
export const api = axios.create({
  baseURL: BACKEND_URL ? `${BACKEND_URL}/api` : "/api",
  timeout: 20000,
  headers: {
    "Bypass-Tunnel-Reminder": "true",
  },
});

// External master-fb.com API (no /api prefix — endpoints like /cola-gallery).
// Used by the browser directly; CORS is whitelisted by Robert/master-fb on the upstream.
export const externalApi = axios.create({
  baseURL: EXTERNAL_API_URL,
  timeout: 20000,
});
